// State argument is not application state, only the state this reducer is responsible for
function styles(state = null, action) {
    switch (action.type) {
      case "SET_STYLES":
        return action.value;
      default:
        return state;
    }
  }
  export default styles;
  